import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getTrainingAttendance } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";

const TrainingAthletesModal = ({ show, onHide, trainingId, trainingName }) => {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !trainingId) return;
    setLoading(true);
    setAthletes([]);
    // date=null → backend defaults to today, but we only need athlete list (status ignored)
    getTrainingAttendance(trainingId, null)
      .then((res) => {
        const data = res?.data?.data;
        setAthletes(Array.isArray(data) ? data : []);
      })
      .catch(() => setAthletes([]))
      .finally(() => setLoading(false));
  }, [show, trainingId]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ borderBottom: "1px solid #f0f0f0" }}>
        <Modal.Title style={{ fontSize: "16px", fontWeight: 700 }}>
          Athletes — {trainingName || "Training"}
          {athletes.length > 0 && (
            <span style={{ fontSize: "13px", fontWeight: 400, color: "#666", marginLeft: "8px" }}>
              ({athletes.length} athletes)
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <table className="table mb-0">
          <thead>
            <tr style={{ background: "#8757e8" }}>
              <th className="text-white fw-semibold py-3 px-4">#</th>
              <th className="text-white fw-semibold py-3 px-4">Athlete Name</th>
              <th className="text-white fw-semibold py-3 px-4">Atom ID</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="text-center py-4">Loading...</td>
              </tr>
            ) : athletes.length > 0 ? (
              athletes.map((a, idx) => (
                <tr key={`${a.athlete_id}-${idx}`} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td className="py-3 px-4" style={{ color: "#666" }}>{idx + 1}</td>
                  <td className="py-3 px-4 fw-semibold">{a.name || "—"}</td>
                  <td className="py-3 px-4">{a.atom_id || "—"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center py-4">No athletes mapped to this training</td>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #f0f0f0", justifyContent: "flex-end" }}>
        <button
          className="btn btn-sm"
          style={{ background: "#8757e8", color: "#fff", borderRadius: "8px" }}
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TrainingAthletesModal;
